import { formatDateTime } from '../i18n/format';
import { Button, InputField, StateBadge } from '@sentinel/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { smtpTestSchema, type SmtpSettings } from '@sentinel/shared';
import { deliveryStateOf } from './smtp-status';

const K = 'smtp';

interface Props {
  settings: SmtpSettings;
  busy: boolean;
  onTest: (to: string) => void;
}

/** «Invia email di prova» and the outcome of the last delivery: a state with its word, and the
 *  reason in plain words when it failed (never the server's message). */
export function EmailTestSection({ settings, busy, onTest }: Props) {
  const { t } = useTranslation();
  const [to, setTo] = useState('');
  const [error, setError] = useState<string | undefined>(undefined);
  const state = deliveryStateOf(settings);
  const time = settings.lastAttemptAt === null ? '' : formatDateTime(settings.lastAttemptAt);

  const send = () => {
    const parsed = smtpTestSchema.safeParse({ to });
    setError(parsed.success ? undefined : t(`${K}.errors.to`));
    if (parsed.success) onTest(parsed.data.to);
  };

  return (
    <div className="stack">
      <b>{t(`${K}.test.title`)}</b>
      <StateBadge tone={state.tone} label={t(`${K}.last.${state.key}`, { time })} />
      {state.reason === null ? null : <p className="note">{t(`${K}.reasons.${state.reason}`)}</p>}
      <InputField
        id="smtp-test-to"
        label={t(`${K}.test.to`)}
        type="email"
        value={to}
        onChange={(e) => setTo(e.target.value)}
        error={error}
      />
      <Button
        onClick={send}
        disabled={busy || !settings.configured}
        style={{ alignSelf: 'flex-start' }}
      >
        {t(`${K}.test.send`)}
      </Button>
    </div>
  );
}
